// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgEyeClose16 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.324 13.026a.446.446 0 0 0 .639 0 .446.446 0 0 0 0-.64L3.66 3.096a.457.457 0 0 0-.644 0 .46.46 0 0 0 0 .639l9.308 9.292Zm.505-1.778c1.563-1.074 2.513-2.492 2.513-3.115 0-1.09-2.9-4.662-7.347-4.662-.913 0-1.757.15-2.53.403l1.584 1.59c.301-.108.618-.173.951-.173a2.846 2.846 0 0 1 2.857 2.842c0 .333-.064.655-.182.95l2.154 2.165Zm-4.834 1.547c.961 0 1.853-.167 2.648-.446l-1.596-1.595a2.63 2.63 0 0 1-1.047.22 2.871 2.871 0 0 1-2.863-2.841c0-.376.08-.741.22-1.064l-2.094-2.1C1.625 6.06.653 7.504.653 8.133c0 1.085 2.959 4.662 7.342 4.662Zm1.74-4.775c0-.935-.757-1.692-1.697-1.692-.038 0-.081 0-.119.005l1.81 1.805c.006-.037.006-.075.006-.118Zm-3.491.075c0 .935.768 1.697 1.702 1.697.043 0 .08-.005.124-.01L6.249 7.96c-.005.043-.005.091-.005.134Z"
		/>
	</svg>
);
export default SvgEyeClose16;
